// AdminUserOverview.js
import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import Dialog from "./Dialog/Dialog";

const roles = ["Admin", "Principal", "Accountant", "Coordinator"];

const AdminUserOverview = ({ selectedUser, onDelete, onUpdate, onClose }) => {
  const [userData, setUserData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    role: roles[0],
  });

  const [dialog, setDialog] = useState({
    isOpen: false,
    type: "",
    title: "",
    message: "",
    onConfirm: null,
    onCancel: null,
  });

  useEffect(() => {
    if (selectedUser) {
      setUserData({
        firstName: selectedUser.firstName,
        middleName: selectedUser.middleName,
        lastName: selectedUser.lastName,
        role: selectedUser.role,
      });
    }
  }, [selectedUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    setDialog({
      isOpen: true,
      type: "confirm",
      title: "Confirm Update",
      message: "Are you sure you want to update this user data?",
      onConfirm: confirmUpdate,
      onCancel: () => setDialog({ isOpen: false }),
    });
  };

  const confirmUpdate = () => {
    // Simulate successful update
    onUpdate({
      id: selectedUser.id,
      name: `${userData.firstName} ${userData.middleName} ${userData.lastName}`,
      role: userData.role,
    });
    setDialog({ isOpen: false });
  };

  const handleDelete = () => {
    setDialog({
      isOpen: true,
      type: "confirm",
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this user?",
      onConfirm: confirmDelete,
      onCancel: () => setDialog({ isOpen: false }),
    });
  };

  const confirmDelete = () => {
    // Simulate successful deletion
    onDelete(selectedUser.id);
    setDialog({ isOpen: false });
  };

  return (
    <div className="admin-user-overview box">
      <div className="overview-header">
        <h2 className="main-heading">Admin Users Overview</h2>
        <button className="close-btn" onClick={onClose}>
          <IoMdClose />
        </button>
      </div>
      <form onSubmit={handleUpdate}>
        <div className="form-row">
          <div className="form-group">
            <label>First Name</label> <br></br>
            <input
              type="text"
              className="form-control"
              name="firstName"
              value={userData.firstName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Middle Name</label> <br></br>
            <input
              type="text"
              className="form-control"
              name="middleName"
              value={userData.middleName}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              className="form-control"
              name="lastName"
              value={userData.lastName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Role</label>
            <select
              name="role"
              className="form-control"
              value={userData.role}
              onChange={handleChange}
            >
              {roles.map((role, index) => (
                <option key={index} value={role}>
                  {role}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          type="button"
          className="badge bg-danger"
          onClick={handleDelete}
          style={{ marginRight: "10px" }}
        >
          Delete
        </button>
        <button type="submit" className="badge bg-success">
          Update
        </button>
      </form>
      <Dialog
        isOpen={dialog.isOpen}
        type={dialog.type}
        title={dialog.title}
        message={dialog.message}
        onConfirm={dialog.onConfirm}
        onCancel={dialog.onCancel}
      />
    </div>
  );
};

export default AdminUserOverview;
